import React from "react";
import { Route, Redirect } from "react-router-dom";
import Authentication from "../../Store/Authentication/AuthenticationStore";

interface IProps {
    exact?: boolean;
    path: string;
    component: React.FC<any>;
    role: "ADMIN" | "ADJUDICATOR" | "EITHER"
}

const PrivateRoute: React.FC<IProps> = ({ component: Component, ...otherProps }: IProps) => {

    const isAuth = (props: any) => {
        return (
            <Component {...props} />
        )
    }

    const isNotAuth = (props: any) => {
        return (
            <Redirect to={{ pathname: "/login", state: { referrer: props.location } }} />
        )
    }

    return (
        <Route
            {...otherProps}
            render={props => {
                if (otherProps.role === "EITHER") {
                    return isAuth(props)
                }
                if (otherProps.role === "ADMIN") {
                    return (Authentication.isAdminAuthenticated() ? isAuth(props) : isNotAuth(props))
                } 
                if (otherProps.role === "ADJUDICATOR") {
                    return (Authentication.isAdjudicatorAuthenticated() ? isAuth(props) : isNotAuth(props))
                }
                isNotAuth(props)
            }}
        />
    );
}

export default PrivateRoute;
